import request from '../utils/request'

// 提交申请表
export function newAddApplyApi(params) {
  return request.post('/api/xt_library_declare/newAddApply', params)
}
// 提交申报表
export function newAddDeclareApi(params) {
  return request.post('/api/xt_library_declare/newAddDeclare', params)
}
// 提交审核
export function examineApi(params) {
  return request.get('/api/xt_library_declare/examine', { params })
}
// 在线申报数据
export function declareDataApi(params) {
  return request.get('/api/xt_library_declare/declareData', { params })
}
// 示范图书馆文章详情
export function articleDataApi(params) {
  return request.get('/api/xt_school_news_detail', { params })
}
